import React from 'react';
import { ReactComponent as IconFacebook } from './assets/icons/facebook.svg';
import { ReactComponent as IconTwitter } from './assets/icons/twitter.svg';
import { ReactComponent as IconGithub } from './assets/icons/github.svg';
import "./App.css";

class App extends React.Component {
  render = () => {
    return (
      <div className="card">
        <div className="header">
          <div className="logo">
            <a href=".">mog.space</a>
          </div>
          {/*<div className="social">*/}
          {/*  <a href="https://facebook.com" title="Facebook" target="_blank" rel="noopener noreferrer">*/}
          {/*    <IconFacebook className="icon" />*/}
          {/*  </a>*/}
          {/*  <a href="https://twitter.com" title="Twitter" target="_blank" rel="noopener noreferrer">*/}
          {/*    <IconTwitter className="icon" />*/}
          {/*  </a>*/}
          {/*  <a href="https://github.com/arkn98/coming-soon" title="GitHub" target="_blank" rel="noopener noreferrer">*/}
          {/*    <IconGithub className="icon" />*/}
          {/*  </a>*/}
          {/*</div>*/}
        </div>
        <div className="content">
          <div className="title-holder">
            <h1>Site is under construction</h1>
            <p>Website coming soon. Please check back to know more. Send us email info@mog.space pr@mog.space</p>
          </div>
          <a href="mailto:info@mog.space">
            <div className="cta">Send us an email</div>
          </a>
        </div>
        <div className="footer">
          <span>info@mog.space | pr@mog.space | &copy;  2024 mog.space</span>
        </div>
      </div>
    );
  }
}

export default App;